import Axios from "axios";
import { size } from "lodash";
import { element } from "prop-types";

export class LandTenureClient {
    /**
     * @type Axios
     */
    client = {};

    constructor() {
        this.client = Axios.create({
            baseURL: 'https://hermes.imaflora.org',
            timeout: 700000,
            validateStatus: () => true
        });
    }

    async getYears() {

        const resp = await this.client.get("landtenure/version");
        var results = [];

        resp.data.forEach(element => {
            results.push({
                'label': element.lt_year,
                'value': element.lt_year
            });
        });

        return results;
    }

    async getLandTenure(filters, period, territories, lt_year) {

        var periodList = [];
        for (let iYear = period.start; iYear <= period.end; iYear++) {
            periodList.push(iYear.toString());
        }

        const unit = ((filters.measurement == '2') ? 'area' : 'num');
        const year = periodList.join(',');
        const theme = filters.themes.join(',');
        const subthemes = filters.subthemes.join(',');
        const classes = filters.categories.join(',');
        const subclasses = filters.subcategories.join(',');
        const sizes = filters.sizes.join(',');
        const results = {
            results: [],
            original: []
        };

        var tGroups = [
            { items: territories.filter(t => t.isAggregated), isAggregated: true },
            { items: territories.filter(t => t.isAggregated == false), isAggregated: false },
        ];

        for (var groupTerritories of tGroups) {
            if (groupTerritories.items.length > 0) {
                var reqParams = {}

                var cd_muns = [];

                groupTerritories.items.forEach((t) => {
                    cd_muns.push(t.cd_muns);
                })

                if (lt_year !== undefined) {
                    reqParams["lt_year"] = lt_year;
                }

                if (year !== undefined && year.length > 0) {
                    reqParams["year"] = year;
                }

                if (theme !== undefined && theme.length > 0) {
                    reqParams["theme"] = theme;
                }

                if (subthemes !== undefined && subthemes.length > 0 && theme != 1) {
                    reqParams["subtheme"] = subthemes;
                }

                if (classes !== undefined && classes.length > 0) {
                    reqParams["owership_class"] = classes;
                }

                if (subclasses !== undefined && subclasses.length > 0) {
                    reqParams["ownership_subclass"] = subclasses;
                }

                if (sizes !== undefined && sizes.length > 0) {
                    reqParams["size"] = sizes;
                }

                if (cd_muns !== undefined && cd_muns.length > 0) {
                    reqParams["city"] = cd_muns.join(',');
                }

                reqParams["aggregate"] = groupTerritories.isAggregated;

                const resp = await this.client.post("landtenure", reqParams, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (resp.status == 200) {
                    resp.data.forEach(element => {
                        var produto = (element.subtheme_name !== undefined ? element.subtheme_name : element.theme_name);
                        produto += " - " + element.size_name;

                        results.results.push({
                            "pesquisa": element.theme_name,
                            "produto": produto,
                            "grandeza": (unit == 'num' ? "num_quantidade" : "area"),
                            "valor": (unit == 'num' ? element.property_count : element.area_ha),
                            "unidade": unit,
                            "territorio": (reqParams["aggregate"] ? element.ownership_subclass_name : (element.city_name + " - " + element.state_code)),
                            "ano": element.year,
                            "__typename": "SurveyResult"
                        })

                        results.original.push(element);
                    });
                }
            }
        }
        return results;
    }

    async getThemes(year) {
        const resp = await this.client.get("landtenure/theme", {
            params: {
                lt_year: year
            }
        });


        var themes = [];
        if (resp.status == 200) {
            const themesRes = resp.data;

            for (var thm of themesRes) {
                const subThemes = await this.client.get("landtenure/subtheme", {
                    params: {
                        lt_year: year,
                        id_theme: thm.id_theme
                    },
                });

                themes.push({
                    name: thm.theme_name,
                    id: thm.id_theme,
                    years: thm.years,
                    subThemes: subThemes.status == 200 ? subThemes.data : []
                });
            }
        }

        return themes;
    }

    async getSizes(year) {
        const resp = await this.client.get("landtenure/size", {
            params: {
                lt_year: year
            }
        });

        return resp.data;
    }

    async getCategories(year) {
        const resp = await this.client.get("landtenure/ownershipclass", {
            params: {
                lt_year: year
            },
        });

        var categories = [];
        if (resp.status == 200) {
            const classes = resp.data;

            for (var cat of classes) {
                var subClasses = await this.client.get("landtenure/ownershipsubclass", {
                    params: {
                        lt_year: year,
                        id_ownership_class: cat.id_ownership_class
                    },
                });

                categories.push({
                    name: cat.ownership_class_name,
                    id: cat.id_ownership_class,
                    subcategories: subClasses.status == 200 ? subClasses.data : []
                });
            }
        }

        return categories;
    }
}


// WEBPACK FOOTER //
// ./src/services/LandTenureClient/LandTenureClient.js